import { makeStyles, Grid, Typography } from '@material-ui/core/';
import React from 'react';
import { ReferenceInput, required, SelectInput, TextInput } from 'react-admin';

import DateInput from '../../core/components/forked/input/DateInput';
import {
  fieldLengthValidator,
  isValidDate,
  formatDate
} from '../../core/utils/index';
import { fundStatus } from './FundLookups';
import {
  emailFormatter,
  emailParser,
  validateEmails,
  validateFundIdRa
} from './creationSteps/utils';
import TagInput from '../../core/components/inputs/TagInput';

// Styling overrides
const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '0px !important'
  }
});

/**
 * Fund summary component. Shared by fund edit and create
 */
const FundSummary = props => {
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.headerContainer}>
          <Typography variant="h5">Fund Details</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="name"
            label="Fund Name"
            validate={[required(), fieldLengthValidator(256)]}
            options={{ autoComplete: 'off' }}
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <ReferenceInput
            label="Fund Type"
            source="classCode"
            resource=""
            reference="fundclasses"
            variant="standard"
          >
            <SelectInput optionText="description" validate={[required()]} />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <ReferenceInput
            source="currency"
            resource=""
            reference="currencies"
            variant="standard"
          >
            <SelectInput optionText="code" validate={[required()]} />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <DateInput
            source="startDate"
            label="Start Date"
            validate={[isValidDate]}
            placeholder="MM/dd/yyyy"
            customParseValue={formatDate}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="aka"
            label="A.K.A"
            options={{ autoComplete: 'off' }}
            variant="standard"
            validate={fieldLengthValidator(255)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <ReferenceInput
            label="Fund Family"
            source="fundFamilyId"
            reference="fundfamilies"
            filter={{ orphanVisibility: 'ALL_VISIBLE' }}
            perPage={-1}
            variant="standard"
            disabled={props.disableFundFamily}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <ReferenceInput
            source="currencyAlternate"
            resource=""
            reference="currencies"
            label="Alternative Currency"
            variant="standard"
          >
            <SelectInput optionText="code" />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <DateInput
            source="endDate"
            label="Closing Date/As of Date"
            validate={[isValidDate]}
            placeholder="MM/dd/yyyy"
            customParseValue={formatDate}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="id"
            label="Fund ID"
            disabled={!props.creation}
            validate={[required(), fieldLengthValidator(20), validateFundIdRa]}
            options={{ autoComplete: 'off' }}
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <SelectInput
            source="status"
            label="Fund Status"
            choices={fundStatus}
            validate={[required()]}
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="emailAddresses"
            label="Fund Contact Email"
            format={emailFormatter}
            parse={emailParser}
            validate={[validateEmails, fieldLengthValidator(500)]}
            allowEmpty
            options={{ autoComplete: 'off' }}
            variant="standard"
            helperText={
              'If you input multiple email addresses, separate them with semicolon (;)'
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <DateInput
            source="inceptionDate"
            label="Fund Inception Date"
            validate={[required(), isValidDate]}
            placeholder="MM/dd/yyyy"
            customParseValue={formatDate}
          />
        </Grid>
      </Grid>
      {!props.creation && (
        <TagInput
          id="tagInput-fund"
          label="Fund Tags"
          source="fundTags"
          resource="fundtags"
          hasEditTagPermission={props.hasEditFundTagPermission}
        />
      )}
    </>
  );
};

export default FundSummary;
